import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
import { UitkCardFeaturedHeaderTitleTags } from "./types.js";
export function UitkCardFeaturedHeader({
  children,
  className,
  title,
  color,
  ...attributes
}) {
  const baseClass = "uitk-card-featured-header";
  const cssClassNames = classNames(
    baseClass,
    color === "color-theme-2" ? "uitk-card-featured-header-color-theme-2" : "uitk-card-featured-header-color-theme-1",
    "uitk-card-roundcorner-top-right",
    "uitk-card-roundcorner-top-left",
    className
  );
  const TitleTag = title && title.tag || UitkCardFeaturedHeaderTitleTags.get("p");
  return /* @__PURE__ */ React.createElement("header", { className: cssClassNames, ...attributes }, title && /* @__PURE__ */ React.createElement(TitleTag, { className: classNames("uitk-card-featured-header-title") }, title.text), children);
}
;
UitkCardFeaturedHeader.displayName = "UitkCardFeaturedHeader";
export const UitkCardAlohaFeaturedHeader = UitkCardFeaturedHeader;
